import React from 'react';

import PhoneInputComponent from './containers/PhoneInputComponent';

const isMobileDevice = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  return /android/i.test(userAgent) || (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream);
};

// eslint-disable-next-line react/prop-types
const RescheduleOrCancel = ({ appLink, shop, androidLink, iosLink }) => (
  <div>
    <div className={`u-hide-on-mobile u-mt-8 ${isMobileDevice() && 'u-mb-6'}`}>
      <a className="u-text-large u-td-none u-dotted-border u-co-black u-fw-bold" href={appLink} target="_blank">
        Reschedule
      </a>
      <span className="u-text-large u-fw-bold"> or </span>
      <a className="u-text-large u-td-none u-dotted-border u-co-black u-fw-bold" href={appLink} target="_blank">
        Cancel
      </a>
      <span className="u-text-large u-fw-bold">
          &nbsp;your<br />appointment using our<br />free app.
        </span>
    </div>
    <div className="u-hide-on-desktop u-mt-8 u-mb-4">
      <a className="u-text-big u-td-none u-dotted-border u-co-black u-fw-bold" href={appLink} target="_blank">
        Reschedule
      </a>
      <span className="u-text-big u-fw-bold"> or </span>
      <a className="u-text-big u-td-none u-dotted-border u-co-black u-fw-bold" href={appLink} target="_blank">
        Cancel
      </a>
      <span className="u-text-big u-fw-bold">
          &nbsp;your<br />appointment using our free app.
        </span>
    </div>
    {
      isMobileDevice() && (
        <div className="u-flex">
          <a className="c-store-button u-mr-4" href={androidLink || appLink} target="_blank">
            <img src="https://squire-emails.s3-us-west-1.amazonaws.com/images/google-play.png" alt="" />
          </a>
          <a className="c-store-button" href={iosLink || appLink} target="_blank">
            <img src="https://squire-emails.s3-us-west-1.amazonaws.com/images/app-store.png" alt="" />
          </a>
        </div>
      )
    }
    {
      !isMobileDevice() && <PhoneInputComponent shop={shop} />
    }
  </div>
);

export default RescheduleOrCancel;



// WEBPACK FOOTER //
// ./src/app/notifications/shared/RescheduleOrCancel.jsx